import { Link, useHistory } from "react-router-dom";
import AuthHelper from "components/auth/helpers";
import { useAppSelector } from "redux/hooks";
import uacLogo from "assets/logos/uac.svg";
import utasLogo from "assets/logos/utas.png";
import utasLogoSml from "assets/logos/utas-logo-small.svg";
import { WHITELABEL } from "utils/Constants";
import style from "./style.module.css";
import { Avatar, Button, Dropdown, MenuProps } from "antd";
import { getAvatarColorsByAlpha } from "utils/Colors";
import downOutlined from "assets/icons/down-outlined.svg";
import capitalize from "lodash/capitalize";
import { AppURL } from "utils/Actions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchSchoolContact } from "redux/reducers/SchoolContactSlice";
import { useTranslation } from "react-i18next";
import { initialName } from "utils/Format";

type whiteLabelHeaderConfigType = { [key in WHITELABEL]: { logo: string; logoSml?: string } };

const whiteLabelHeaderConfig: whiteLabelHeaderConfigType = {
  [WHITELABEL.uac]: {
    logo: uacLogo
  },
  [WHITELABEL.utas]: {
    logo: utasLogo,
    logoSml: utasLogoSml
  }
};

const Nav: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const whitelabel = useAppSelector(state => state.properties.whiteLabel);
  const { t } = useTranslation();
  const isLoggedInPage = AuthHelper.isAuthed() && !AuthHelper.isUnencrypted();
  const currentPath = history.location.pathname;
  const { givenName1: name } = useAppSelector(state => state.schoolContact.data);
  const [foregroundColor, backgroundColor] = getAvatarColorsByAlpha(name);

  useEffect(() => {
    dispatch(fetchSchoolContact());
  }, []);

  const logOut = () => {
    history.push("/");
    if (currentPath !== String(history.location.pathname)) {
      AuthHelper.clearAuth();
      history.go(0);
    }
  };

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <Button
          autoFocus
          onClick={() => logOut()}
          type="text"
          className={style["user-menu--dropdown-button"]}
          aria-label="Log out from portal"
        >
          Log out
        </Button>
      )
    }
  ];

  const imgSrc = whitelabel ? whiteLabelHeaderConfig[whitelabel].logo : "";
  const imgSmlSrc =
    whitelabel && whiteLabelHeaderConfig[whitelabel].logoSml
      ? whiteLabelHeaderConfig[whitelabel].logoSml
      : imgSrc;
  const altText = `To ${whitelabel?.toUpperCase()} dashboard`;

  return (
    <div className={style.container}>
      <div className="logo center-content" style={{ marginLeft: "1.5rem" }}>
        <Link to={AppURL.school.path} className={style["logo-container"]}>
          {whitelabel && (
            <>
              <img
                src={imgSrc}
                alt={altText}
                className={[style.logo, style, "hide-mobile"].join(" ")}
              />
              <img
                src={imgSmlSrc}
                alt={altText}
                className={[style.logo, style, "show-mobile"].join(" ")}
              />
            </>
          )}
        </Link>
        <span style={{ lineHeight: "normal" }}>{t("nav.heading")}</span>
      </div>

      {isLoggedInPage && (
        <div className={style["inner-container"]}>
          <div
            id="userMenuContainer"
            style={{ marginRight: 16 }}
            className={style["dropdown-container"]}
          >
            <Dropdown menu={{ items }} trigger={["click"]}>
              <a onClick={e => e.preventDefault()} href="#" className={style["link-container"]}>
                <Avatar
                  style={{
                    color: foregroundColor,
                    backgroundColor: backgroundColor,
                    marginRight: 8
                  }}
                  size={32}
                  aria-hidden={true}
                >
                  {initialName(name)}
                </Avatar>
                <span style={{ color: "white", marginRight: 8 }}>{capitalize(name)}</span>
                <img
                  src={downOutlined}
                  alt="Down arrow icon to open the menu for logout"
                  style={{ marginTop: 2 }}
                />
              </a>
            </Dropdown>
          </div>
        </div>
      )}
    </div>
  );
};

export default Nav;
